/**
 * Hooks into window.dreamdata.ready() once the standard snippet has been activated, and signals
 * the DreamdataAwareUiEvents queue that Dreamdata is ready to receive calls.
 *
 * Page tracking is handled by dreamdata.init() (called by dreamdataBootstrap.js when consent is
 * granted), which fires dreamdata.page() itself - no separate page-view call is needed here.
 */
function init(markReady) {
  try {
    if (!window.dreamdata) {
      return;
    }
    window.dreamdata.ready(() => {
      markReady();
    });
  } catch (e) {
    // Swallow - Dreamdata must never break signup.
  }
}

export default { init };
